module.exports = __webpack_public_path__ + "img/智慧能效平台.6461d027.png";